<template>
  <div style="display:flex; justify-content:center; margin-top:100px">
    <div style="width:100%">
      <div style="width:100%; background-color:#EDFBFF;display: flex;justify-content: center; position:relative">
        <img src="@/assets/images/activitybanner.png"
             style="width:100%">

        <div style="position:absolute;top: 35%; left:15%">
          <span style="font-size:48px; color:black; font-family: 'SourceHanSansSC-bold'; font-weight:bold">NZONE手机服务日活动</span>

        </div>
      </div>

      <div style="margin-top:75px">
        <p class="content2">活动内容</p>
      </div>

      <div style="display:flex; justify-content:center">
        <div style="margin-top:50px; display:flex; justify-content:space-around; align-items:center; width:1300px">
          <!-- <img src="@/assets/images/activityshow.png"> -->
          <div class="activity">
            <img src="@/assets/images/activity1.png"
                 style="width:270px">
            <div class="position">
              <span class="font_title">免费</span><span class="font">贴膜</span><br>
              <div style="margin-top:10px"><span class="font">活动期间，NZONE手机产品可享受免费贴膜服务</span>

              </div>

            </div>
          </div>
          <div class="activity">
            <img src="@/assets/images/activity4.png"
                 style="width:270px">
            <div class="position">
              <span class="font_title">免费</span><span class="font">外观清洁</span><br>
              <div style="margin-top:10px"><span class="font">活动期间，NZONE手机产品可享受免费外观清洁服务</span></div>

            </div>
          </div>
          <div class="activity">
            <img src="@/assets/images/activity2.png"
                 style="width:270px">
            <div class="position">
              <span class="font_title">免费</span><span class="font">消毒保养</span><br>
              <div style="margin-top:10px"><span class="font">活动期间，NZONE手机产品可享受免费消毒保养服务</span></div>

            </div>
          </div>
          <div class="activity">
            <img src="@/assets/images/activity3.png"
                 style="width:270px">
            <div class="position">
              <span class="font">保外维修</span> <span class="font_title">免人工费</span><br>
              <div style="margin-top:10px"><span class="font">活动期间，到店保外维修可以减免人工费</span></div>

            </div>
          </div>
        </div>

      </div>

      <div style="margin-top:50px">
        <p class="content"
           style="color:#646464">
          说明：
        </p>
        <p class="content"
           style="color:#646464">
          1) 活动期限内（2021年9月-2023年8月）每台设备仅限参与一次

        </p>
        <p class="content"
           style="color:#646464">
          2) 寄修服务暂时不支持参加服务日活动
        </p>
      </div>

      <hr />

      <div>
        <p class="content2"
           style="margin-top:50px">活动时间</p>
      </div>

      <div>
        <p class="content"
           style="margin-top:50px">每月第一个连续的周五~周日</p>
        <p class="content"
           style="margin-top:50px;color:#646464">说明：如遇周末跨月，则顺延至下一个周末（例：2022年5月为6-8日）</p>

      </div>

      <hr />

      <div>
        <p class="content2">活动地点</p>
      </div>

      <div style="margin-bottom:100px">
        <p class="content"
           style="margin-top:50px">中国大陆地区NZONE授权客户服务中心</p>
        <p class="content"
           style="margin-top:50px;color:#646464">说明：到店参与服务日活动，建议您提前致电门店咨询活动开展情况</p>
        <p class="content"
           style="margin-top:50px;cursor:pointer; margin-top:50px; padding-bottom:5px;border-bottom:2px solid #000;display: inline-block; "
           @click="$router.push('/shop')">立即查询</p>
      </div>

    </div>

  </div>

</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  methods: {
    returnIndex() {
      this.$router.push("/");
    },
  },
  setup() {
    return {};
  },
});
</script>
<style scoped>
.title {
  font-size: 48px;
  font-style: SourceHanSansSC;
  color: #010101;
  font-weight: bold;
  letter-spacing: 2px;
}

.content {
  font-size: 20px;
  font-family: "SourceHanSansSC-regular";
  color: #010101;
  letter-spacing: 1px;
}

.content2 {
  font-size: 36px;
  font-family: "SourceHanSansSC-regular";
  color: #010101;
  /* font-weight: bold; */
  margin-top: 30px;
}

.content3 {
  font-size: 16px;
  font-style: SourceHanSansSC-regular;
  color: #010101;
  margin-left: 40px;
  line-height: 35px;
}

.div2 {
  max-width: 1250px;
  text-align: center;
}

.div3 {
  max-width: 1250px;
  text-align: left;
}

hr {
  width: 80%;
  margin-top: 100px;
  margin-bottom: 100px;
}

.activity {
  position: relative;
}

.font {
  color: white;
  font-size: 20px;
  font-family: "SourceHanSansSC-regular";
  line-height: 30px;
}

.font_title {
  color: white;
  font-size: 32px;
  font-family: "SourceHanSansSC-regular";
}

.position {
  position: absolute;
  top: 120px;
  left: 20px;
  margin-right: 20px;
  text-align: left;
}
</style>
